function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Web &amp; App");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 356,
  height: 145,
  rx: 3
}), /*#__PURE__*/React.createElement("filter", {
  x: "-8.4%",
  y: "-20.7%",
  width: "116.9%",
  height: "141.4%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10,
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
  type: "matrix",
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 0,
  in: "SourceAlpha",
  result: "shadowOffsetOuter2"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  in: "shadowOffsetOuter2",
  result: "shadowBlurOuter2"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
  type: "matrix",
  in: "shadowBlurOuter2",
  result: "shadowMatrixOuter2"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter2"
}))));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Web-&-App",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home-List",
  transform: "translate(-358.000000, -3244.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4-Copy-2",
  transform: "translate(30.000000, 3231.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Flag",
  transform: "translate(322.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 7,
  y1: 6,
  x2: 7,
  y2: 16,
  id: "Line-3",
  stroke: "#E8C103",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7,6 C7.55517163,5.29708804 8.3660608,5.02052118 9.43266749,5.1702994 C11.0325775,5.39496674 11.3593615,6.6020286 12.5370982,6.77754692 C13.322256,6.89455914 14.1432233,6.63537683 15,6 L15,11 C14.4929844,11.6254721 13.7046478,11.863469 12.6349903,11.7139906 C11.030504,11.4897731 10.723126,10.3865269 9.51084401,10.2329228 C8.70265601,10.13052 7.86570801,10.3862124 7,11 L7,6 Z",
  id: "Rectangle",
  stroke: "#E8C103",
  fill: "#E8C103",
  strokeLinejoin: "round"
})))));

var SvgFlagOrange = function SvgFlagOrange(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "13px",
    viewBox: "0 0 10 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFlagOrange, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/flag_orange.ec6c25de.svg";
export { ForwardRef as ReactComponent };